import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const AaaWelcomePartnerPage = loadable(() =>
  withDefaultLoaderModifiers(import("./AaaWelcomePartnerPage"))
);
